<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Edit File] - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="$root.getUrl(file)">{{ $root.getRecordName(file) }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Edit: {{ file.file_title ? file.file_title : file.file_name }}</li>
                </ol>
            </nav>

            <h4 class="page-header">
                Edit: {{ file.file_title ? file.file_title : file.file_name }}
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-lg-6 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Edit File</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right text-muted" :class="{'text-danger': errors.file_title, 'text-muted-no': !errors.file_title}">
                                    File Title:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="file.file_title" :class="{'form-control': true, 'is-invalid': errors.file_title}" placeholder="Enter File Name" />

                                    <div class="text-danger mt-2" v-if="errors.file_title">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.file_title">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right text-muted" :class="{'text-danger': errors.file_title, 'text-muted-no': !errors.file_title}">
                                    File Name:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ file.file_name }}
                                </div>
                            </div>

                            <div class="row mb-2" v-if="file.record_type === 'Agent' && $root.hasPermission('agents.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_sensitive, 'text-muted-no': !errors.is_sensitive}">
                                    Is Sensitive:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="file.is_sensitive" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_sensitive">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_sensitive">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveFile()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Updating</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                file: {},
                record: {},
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            getFile(){
                //Send it
                this.$http.get('/files/edit/' + this.id)
                    .then(response => {
                        //Set the file
                        this.file = response.data.file;
                        this.record = response.data.record;

                        //Set the Types for the getRecordName file 
                        this.file.record = this.record;

                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveFile(){
                //Helpers
                this.saving = true;

                //Send it
                this.$http
                .post('/files/edit/'+this.file.id, this.file)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('File Updated');

                    //Return to main list?
                    this.$router.push(this.$root.getUrl(this.file));
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save File');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {
            //get the file?
            this.getFile();
        }
    }
</script>
